import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '../utilities/utilities.module';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '../components/components.module';
import { SiteMapListComponent } from './site-map-list/site-map-list.component';
import { SiteMapListDataService } from './site-map-list-data.service';
import { SiteMapService } from './site-map.service';
import { SiteMapConfirmDeleteComponent } from './site-map-confirm-delete/site-map-confirm-delete.component';
import { SiteMapContentNameColumnComponent } from './site-map-content-name-column/site-map-content-name-column.component';
import { SiteMapViewComponent } from './site-map-view/site-map-view.component';
import { SiteMapEditContentComponent } from './site-map-edit/content/site-map-edit-content.component';
import { SiteMapEditContentDragIconComponent } from './site-map-edit/content/site-map-edit-content-drag-icon.component';
import { MatIconModule } from '@angular/material/icon';
import { SiteMapEditGeneralComponent } from './site-map-edit/general/site-map-edit-general.component';
import { SiteMapEditComponent } from './site-map-edit/site-map-edit.component';
import { SiteMapContentNameColumnLinkComponent } from './site-map-content-name-column-link/site-map-content-name-column-link.component';
import { UIRouterModule } from '@uirouter/angular';
import { SiteMapStates } from '@fi-app/site-map/site-map-states';
import { FiStateSrefAccessModule } from '@fi-app/utilities/state-sref-access/state-sref-access.module';
import { MatButtonModule } from '@angular/material/button';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SiteMapTableNewComponent } from './site-map-edit/site-map-table-new/site-map-table-new.component';
import { SiteMapTableItemNewComponent } from './site-map-edit/site-map-table-new/site-map-table-item-new/site-map-table-item-new.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { DndModule } from 'ngx-drag-drop';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FormsModule,
        ComponentsModule,
        MatIconModule,
        MatButtonModule,
        UIRouterModule.forChild(SiteMapStates),
        FiStateSrefAccessModule,
        DragDropModule,
        MatExpansionModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatCardModule,
        SelectSearchModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        MatRadioButton,
        MatRadioGroup,
        MatMenuModule,
        DndModule,
    ],
    declarations: [
        SiteMapListComponent,
        SiteMapConfirmDeleteComponent,
        SiteMapContentNameColumnComponent,
        SiteMapContentNameColumnLinkComponent,
        SiteMapViewComponent,
        SiteMapEditContentComponent,
        SiteMapEditContentDragIconComponent,
        SiteMapEditGeneralComponent,
        SiteMapEditComponent,
        SiteMapTableNewComponent,
        SiteMapTableItemNewComponent,
    ],
    exports: [SiteMapEditComponent, SiteMapTableNewComponent],
    providers: [SiteMapService, SiteMapListDataService],
})
export class SiteMapModule {}
